import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=0f55036d"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webp_aaeg4c7xsv2rwjah5qgerw23gy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonIcon: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/ui/button/Icon.vue').default,UiModalShare: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/ui/Modal/Share.vue').default})
